import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  activate(event) {
    if (event.key !== "Enter" || this.element.disabled) return

    event.preventDefault()
    this.element.click()
  }
}
